module.exports = window.ReactDomClient